import { Country } from "types";

export const getLineChartData = (countryData: Country[], selectedCountries: string[], selectedMetricDetails: any, showPercentage: boolean, yearRange: number[]): any[] => {
    const filteredCountries = countryData.filter(i => selectedCountries.includes(i?.countryCode))
    let returnData: any[] = []
    yearRange.forEach(eachYear => {
        let obj: any = {
            year: eachYear
        }
        /* filteredCountries.forEach(eachCountry => {
            let yrData = eachCountry.metadatas.find(i => i.PublishYear === eachYear)
            if (yrData) {
                obj[`${eachCountry?.countryCode}`] = isNaN(yrData[selectedMetricDetails?.shortname_raw] as number) ? 0 : !showPercentage ? yrData[selectedMetricDetails?.shortname_raw] : Number(yrData[selectedMetricDetails?.shortname_raw]) * 100
            } else {
                obj[`${eachCountry?.countryCode}`] = 0
            }

        })
        returnData.push(obj) */
        filteredCountries.forEach(eachCountry => {
            let yrData = eachCountry.metadatas.find(i => i.PublishYear === eachYear)
            if (yrData) {
                const rawValue = yrData[selectedMetricDetails?.shortname_raw];
                const processedValue = !showPercentage ? rawValue : Number(rawValue) * 100;
                
                // Only add country data if it's a valid number (including 0)
                // Use null for invalid data to maintain line continuity
                if (!isNaN(Number(processedValue)) && processedValue !== null && processedValue !== undefined && processedValue !== '') {
                    obj[`${eachCountry?.countryCode}`] = processedValue;
                } else {
                    obj[`${eachCountry?.countryCode}`] = null; // Use null instead of removing property
                }
            } else {
                // No data found for this year - use null to create gap that can be connected
                obj[`${eachCountry?.countryCode}`] = null;
            }
        })
        returnData.push(obj)
    });
    
    
    // Filter out years where all country values are 0, NaN, or empty
    returnData = returnData.filter(yearData => {
        const countryValues = Object.keys(yearData)
            .filter(key => key !== 'year')
            .map(key => yearData[key]);
        
        return countryValues.some(value => 
            value !== 0 && 
            value !== '' && 
            !isNaN(value) && 
            value !== null && 
            value !== undefined
        );
    });
    console.log('getLineChartData', returnData);
    return returnData

}